import { getEnvironment } from '../../../../core/env/environment';
import { ThemeZone } from '../kiosk-theme-form/form';

export const DEFAULT_KIOSK_BACKGROUND_FILENAMES: Record<ThemeZone, string> = {
  light: 'background_white_768.png',
  dark: 'background_black_768.png'
};

function getBlobHost(): string {
  const env = getEnvironment();
  return `https://gflockercloudbroker${env.type}.blob.core.windows.net`;
}

export function getDefaultKioskBackgroundUrl(zone: ThemeZone): string {
  return `${getBlobHost()}/assets/${DEFAULT_KIOSK_BACKGROUND_FILENAMES[zone]}`;
}

export function isDefaultKioskBackgroundUrl(url: string | undefined): boolean {
  if (!url) return false;
  return Object.values(DEFAULT_KIOSK_BACKGROUND_FILENAMES).some((filename) => url.endsWith(`/assets/${filename}`));
}
